import React, { useEffect, useState } from "react";
import { SingleCardMetric } from "../ui/SingleCardMetric";
import { parseLocalDate } from "../../../helpers/date";

interface ShelterIntakeDayMetricState {
  data: any;
  setSelectedData: (data: any[] | null) => void;
  readOnly: boolean;
  active: boolean;
  onHandleClick?: any;
}

export const ShelterIntakeDayMetric = ({ data, setSelectedData, readOnly = true, active, onHandleClick }: ShelterIntakeDayMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [dayRange, setDateRange] = useState<number>(7);
  const [current, setCurrent] = useState<string>();
  const [currentData, setCurrentData] = useState<any[]>();

  useEffect(() => {
    if (data) {
      const { intakes, start } = data;
      let range = 7;
      if (start) {
        range = getDayRangeFromStartDate(start);
        setDateRange(range);
      }
      const recentIntakes = intakes?.filter((item: any) => isWithinLastXDays(item, range));
      const recentIntakesCount = recentIntakes?.length.toString();
      setCurrent(recentIntakesCount);
      setCurrentData(recentIntakes);
      if (active) {
        setSelectedData(recentIntakes);
      }
    }
    setIsLoading(false);
  }, [data]);

  function getDayRangeFromStartDate(start: string): number {
    const today = new Date();
    today?.setHours(0, 0, 0, 0);
    const startDate = parseLocalDate(start);
    startDate?.setHours(0, 0, 0, 0);
    const dayRangeTime: number = today.getTime() - startDate.getTime();
    return Math.round(dayRangeTime / (1000 * 60 * 60 * 24));
  }

  function isWithinLastXDays(item: any, dayRange: number) {
    const today = new Date();
    const intakeDate = parseLocalDate(item.intake_at);
    today?.setHours(0, 0, 0, 0);
    intakeDate?.setHours(0, 0, 0, 0);

    const diffInTime: number = today.getTime() - intakeDate.getTime();
    const diffInDays = Math.round(diffInTime / (1000 * 60 * 60 * 24));

    return diffInDays >= 0 && diffInDays <= dayRange; // dayRange days + today
  }

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(currentData || null);
    } else {
      setSelectedData(null);
    }
    onHandleClick();
  };

  if (readOnly) {
    return <SingleCardMetric title={`Intakes Last ${dayRange} Days`} total={current} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={`Intakes Last ${dayRange} Days`}
        total={current}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
